import { personsCodes, purchasesCodes, salesCodes } from "../data/main";
import { getPrefix } from "./getPrefix";

export const getRealCode = (code: string, key: string) => {
  key = key === "CAJ" ? "ORD" : key;
  if (purchasesCodes.includes(key)) {
    switch (getPrefix(code)) {
      case "ANO":
      case "AGE":
        return "AGE2";
      case "FEC2":
        return "FEC4";
      case "CLI":
        return "ID2";
      case "NOM":
        return "PRO";
    }
  } else if (salesCodes.includes(key)) {
    switch (getPrefix(code)) {
      case "ANO":
      case "AGE":
        return "AGE2";
      // case "FEC2":
      //   return "FEC4";
      case "CLI":
        return "ID";
      case "NOM":
        return "CLI";
    }
  } else if (personsCodes.includes(key) && getPrefix(code) === "COD") {
    return key === "PRO" ? "ID2" : "ID";
  }
  return code.endsWith(key) ? getPrefix(code) : code;
};
